import * as React from "react";
const SvgClear = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fill: "var(--text-primary)",
	d: "M37.5252 4.84905L27.958 14.4162L28.8021 15.3307C30.2794 16.808 30.5608 18.9888 29.576 20.7474L20.6419 36.8569C20.2198 37.5603 19.446 37.9824 18.6722 37.9824C18.0391 37.9824 17.4763 37.7714 17.0542 37.3493L2.63312 22.9282C2.21104 22.5061 2 21.9433 2 21.3102C2 20.5364 2.42208 19.7626 3.12555 19.3405L19.235 10.4064C20.9936 9.42159 23.1744 9.70298 24.6517 11.1803L25.5662 12.0244L35.1334 2.5276C35.7665 1.82413 36.8217 1.82413 37.5252 2.5276C38.1583 3.16072 38.1583 4.21593 37.5252 4.84905ZM24.722 22.5061L17.4763 15.2604L6.08012 21.5916L8.33122 23.8427L12.1299 22.6468C12.6224 22.4358 13.0445 22.8578 12.9038 23.3503L11.6375 27.149L18.3908 33.9023L24.722 22.5061Z"
}));
export default SvgClear;
